import React, { useState, useEffect } from 'react';
import { Body, Home, Container, WelcomeText, Content } from './styles';
import { connect } from "react-redux";
import Card from './Card';
import Sidenav from 'components/ui/company/Sidenav';
import MetaTags from './MetaTags';
import roles from 'utils/roles';

function Main(props) {
  const [showSidenav, setShowSidenav] = useState(true);
  const { user } = props;

  const cards = [
    {title: "Meu portal", category: "Minha empresa", iconName: "dvr", link: `/empresas/ver/${user?.company_slug}`, permissions: [roles.administrator, roles.personal_department, roles.supervisor, roles.hr_business_partner, roles.recruiter, roles.financial]},
    {title: "Meus colaboradores", category: "Minha empresa", iconName: "groups", link: "/gestores/minhas", permissions: [roles.administrator] },
    {title: "Banco de candidatos", category: "Recrutamento", iconName: "patient_list", link: "/candidatos", permissions: [roles.administrator, roles.recruiter] },
    {title: "Questionários inteligentes", category: "Recrutamento", iconName: "quiz", link: "/ats/questionarios/formularios/minhas", permissions: [roles.recruiter] },
    {title: "Minhas vagas", category: "Recrutamento", iconName: "cases", link: "/vagas/minhas", permissions: [roles.administrator, roles.recruiter] },
    {title: "Eventos e feiras", category: "Agenda", iconName: "calendar_month", link: "/eventos", permissions: [roles.administrator, roles.personal_department, roles.hr_business_partner, roles.recruiter] },
    {title: "Avaliação de estágio", category: "Gestão de estágio", iconName: "emoji_events", link: "/avaliacoes/respostas", permissions: [roles.personal_department, roles.supervisor] },
    {title: "Meus contratos", category: "Gestão de estágio", iconName: "folder_open", link: "/folders/minhas", permissions: [roles.administrator, roles.personal_department, roles.hr_business_partner] },
    {title: "Academy", category: "Desenvolvimento", iconName: "rocket_launch", link: "/academy/meus", permissions: [roles.administrator] },
    {title: "Entrevistas e dinâmicas", category: "Recrutamento", iconName: "3p", link: "/entrevistas/agenda", permissions: [roles.recruiter] },
    {title: "Financeiro", category: "Minha empresa", iconName: "payments", link: "/financeiro/relatorios-da-empresa", permissions: [roles.financial] },
    {title: "Dashboard", category: "Gestão de estágio", iconName: "dashboard", link: "/folders/dashboard", permissions: [roles.hr_business_partner, roles.personal_department] },
    {title: "Todos os documentos", category: "Gestão de estágio", iconName: "topic", link: "/envelopes/minhas", permissions: [roles.personal_department] },
    {title: "Pendências", category: "Gestão de estágio", iconName: "brightness_alert", link: "/estagios/pendencias", permissions: [roles.personal_department] },
    {title: "Meus programas", category: "Minha empresa", iconName: "business_center", link: "/programa_estagio", permissions: [roles.recruiter] },
    {title: "Fale conosco", category: "Suporte", iconName: "chat_info", link: "#", permissions: [roles.administrator, roles.personal_department, roles.supervisor, roles.hr_business_partner, roles.recruiter, roles.financial] },
  ];

  useEffect(() => {
    const handleResize = () => {
      setShowSidenav(window.innerWidth > 1441);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <MetaTags company={user} />
      <Body>
        {showSidenav && <Sidenav />}
        <Home>
          <Container>
            <WelcomeText>
              <h4 className="company_manager_name">Boas vindas, <span>{user?.name}</span></h4>
            </WelcomeText>
            <Content>
              {cards.map((card, index) => (
                <Card
                  key={index}
                  title={card.title}
                  category={card.category}
                  iconName={card.iconName}
                  link={card.link}
                  permissions={card.permissions}
                  userRoles={user?.roles}
                />
              ))}
            </Content>
          </Container>
        </Home>
      </Body>
    </>
  );
}

function mapStateToProps(state) {
  const user = state.session?.attributes;
  return { user };
}

export default connect(mapStateToProps)(Main);